/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeneratePlayoffsResponseQualifiedTeamsInner } from './GeneratePlayoffsResponseQualifiedTeamsInner';
import {
    GeneratePlayoffsResponseQualifiedTeamsInnerFromJSON,
    GeneratePlayoffsResponseQualifiedTeamsInnerFromJSONTyped,
    GeneratePlayoffsResponseQualifiedTeamsInnerToJSON,
    GeneratePlayoffsResponseQualifiedTeamsInnerToJSONTyped,
} from './GeneratePlayoffsResponseQualifiedTeamsInner';
import type { LeagueResponse } from './LeagueResponse';
import {
    LeagueResponseFromJSON,
    LeagueResponseFromJSONTyped,
    LeagueResponseToJSON,
    LeagueResponseToJSONTyped,
} from './LeagueResponse';

/**
 * 
 * @export
 * @interface GeneratePlayoffsResponse
 */
export interface GeneratePlayoffsResponse {
    /**
     * 
     * @type {LeagueResponse}
     * @memberof GeneratePlayoffsResponse
     */
    league: LeagueResponse;
    /**
     * 
     * @type {string}
     * @memberof GeneratePlayoffsResponse
     */
    message?: string;
    /**
     * 
     * @type {Array<GeneratePlayoffsResponseQualifiedTeamsInner>}
     * @memberof GeneratePlayoffsResponse
     */
    qualifiedTeams?: Array<GeneratePlayoffsResponseQualifiedTeamsInner>;
}

/**
 * Check if a given object implements the GeneratePlayoffsResponse interface.
 */
export function instanceOfGeneratePlayoffsResponse(value: object): value is GeneratePlayoffsResponse {
    if (!('league' in value) || value['league'] === undefined) return false;
    return true;
}

export function GeneratePlayoffsResponseFromJSON(json: any): GeneratePlayoffsResponse {
    return GeneratePlayoffsResponseFromJSONTyped(json, false);
}

export function GeneratePlayoffsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratePlayoffsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'league': LeagueResponseFromJSON(json['league']),
        'message': json['message'] == null ? undefined : json['message'],
        'qualifiedTeams': json['qualifiedTeams'] == null ? undefined : ((json['qualifiedTeams'] as Array<any>).map(GeneratePlayoffsResponseQualifiedTeamsInnerFromJSON)),
    };
}

export function GeneratePlayoffsResponseToJSON(json: any): GeneratePlayoffsResponse {
    return GeneratePlayoffsResponseToJSONTyped(json, false);
}

export function GeneratePlayoffsResponseToJSONTyped(value?: GeneratePlayoffsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'league': LeagueResponseToJSON(value['league']),
        'message': value['message'],
        'qualifiedTeams': value['qualifiedTeams'] == null ? undefined : ((value['qualifiedTeams'] as Array<any>).map(GeneratePlayoffsResponseQualifiedTeamsInnerToJSON)),
    };
}

